import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";

import { requestAssignTask } from "../../redux/assignment/assignmentActions";
import { setSelectedLabourer, changeGanttWidth } from "../../redux/gantt/ganttActions";
import { GanttDropTarget } from "../taskDnD/ganttDropTarget";

const LABORERS_WIDTH = 144;
const MIN_GANTT_WIDTH = 850;
const GANTT_SPACING = 34;

const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const calcGanttWidth = (width, numberDays) => {
    const availableWidth = width - LABORERS_WIDTH;

    // should not be possible to have 0 days displayed
    // handle it so we don't have to worry about div by zero
    if (numberDays === 0) {
        return MIN_GANTT_WIDTH;
    }

    // if 4 or more days showing then use the
    // smallest size for the gantt
    if (numberDays >= 4) {
        return MIN_GANTT_WIDTH;
    }

    // Otherwise allocate space evenly for remaining days
    const paddingWidth = (numberDays - 1) * GANTT_SPACING;
    return (availableWidth - paddingWidth) / numberDays;
};

const getDates = (startDate, endDate) => {
    const dateArray = [];
    // If no enddate selected, do 1 day
    const stopDate = endDate ? moment(endDate) : moment(startDate);
    var currentDate = moment(startDate);

    while (currentDate <= stopDate) {
        dateArray.push(currentDate);
        currentDate = moment(new Date(currentDate)).add(1, "days");
    }
    return dateArray;
};

export const MultidayGantt = (props) => {
    const { dateRange, assignments, technicians, tasks, ganttWidth } = props;

    const days = getDates(dateRange.start, dateRange.end);
    // save current window width in the state object
    const [width, setWidth] = useState(getWidth());

    // in this case useEffect will execute only once because
    // it does not have any dependencies.
    useEffect(() => {
        const resizeListener = () => {
            // change width from the state object
            const width = getWidth();
            const ganttWidth = calcGanttWidth(width, days.length);
            setWidth(width);

            // change the gantt widht
            props.changeGanttWidth(ganttWidth);
        };
        // set resize listener
        window.addEventListener("resize", resizeListener);

        // clean up function
        return () => {
            // remove resize listener
            window.removeEventListener("resize", resizeListener);
        };
    }, [days]);

    useEffect(() => {
        // number of days has changed update the ganttWidth
        const ganttWidth = calcGanttWidth(width, days.length);
        props.changeGanttWidth(ganttWidth);
    }, [days.length]);

    return (
        <div
            className="bell-scrollbar"
            style={{
                height: "calc(100% - 100px)",
                width: "100%",
                // display: "table",
                overflowX: "auto",
                position: "relative",
                display: "flex",
            }}>
            <div
                style={{
                    height: "100%",
                    display: "inline",
                    position: "sticky",
                    left: 0,
                    zIndex: 1300,
                    backgroundColor: "var(--grey-background)",
                }}>
                <GanttDropTarget
                    className={"hidden-scroll"}
                    showSidebar={true}
                    noTimeline={true}
                    ganttDate={moment(Date.parse("2020-09-30")).startOf("day")}
                    assignments={assignments}
                    technicians={technicians}
                    tasks={tasks}
                    requestAssignTask={props.requestAssignTask}
                    setSelectedLabourer={props.setSelectedLabourer}
                    selectedLabourer={props.selectedLabourer}
                    timeRange={props.timeRange}
                    width={LABORERS_WIDTH}
                />
            </div>
            {days.map((day, i) => (
                <div
                    key={`${ganttWidth}-${i}`}
                    style={{
                        height: "100%",
                        display: "inline",
                        width: `${ganttWidth + GANTT_SPACING}px`,
                        paddingLeft: i === 0 ? "0px" : "17px",
                    }}>
                    <GanttDropTarget
                        //className={i !== 2 && 'hidden-scroll'}
                        // style={{
                        //     marginRight: "17px"
                        // }}
                        showSidebar={false}
                        ganttDate={day}
                        assignments={assignments}
                        technicians={technicians}
                        tasks={tasks}
                        requestAssignTask={props.requestAssignTask}
                        selectedLabourer={props.selectedLabourer}
                        timeRange={props.timeRange}
                        width={ganttWidth}
                        zones={props.zones}
                        filter={props.filter}
                    />
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = (state) => ({
    assignments: state.assignments.assignments,
    timeRange: state.domain.timeRange,
    ganttWidth: state.gantt.width,
    zones: state.dashboard.zones,
    filter: state.dashboard.filter,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestAssignTask,
            setSelectedLabourer,
            changeGanttWidth,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(MultidayGantt);
